













































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dealTypeMap, currencyMap, totalClassList, exitTypeMap, permil } from '@/utils/finance';
import { dealExit, fundListForExitCommon } from '@/api/finance.js';
import moment from 'moment';

let validNum = (rule, val, cb) => {
  if (!val || /^\d+\.?\d*$/.test(`${val}`)) {
    cb();
  } else {
    cb(new Error('请输入合法数字'));
  }
};

@Component({
  components: {}
})
class ExitDeal extends Vue {
  dealNow: any = {};
  classList: any[] = [];
  form: any = {};
  dealTypeMap = dealTypeMap;
  currencyMap = currencyMap;
  exitTypeMap = exitTypeMap;
  totalClassList = totalClassList;
  fundList: any[] = [];
  inited: boolean = false;

  rules: any = {
    deliveryDate: [{ required: true, message: '请选择退出收款日期', trigger: 'change' }],
    effectDate: [{ required: true, message: '请选择生效时间', trigger: 'change' }],
    investId: [{ required: true, message: '请选择交易', trigger: 'blur' }],
    currency: [{ required: true, message: '请先完成公司事件对本交易的分摊', trigger: 'blur' }],
    amount: [
      { required: true, message: '请填写实收退出金额', trigger: 'blur' },
      { validator: validNum, trigger: 'blur' }
    ],
    shareNum: [
      { required: true, message: '请填写实际退出股份', trigger: 'blur' },
      { validator: validNum, trigger: 'blur' }
    ],
    cost: [
      { required: true, message: '请填写退出部分投资成本', trigger: 'blur' },
      { validator: validNum, trigger: 'blur' }
    ]
  };

  layout1 = { labelCol: { span: 20 }, wrapperCol: { span: 21 } };
  layout2 = { labelCol: { span: 20 }, wrapperCol: { span: 21 } };
  layout3 = { labelCol: { span: 4 }, wrapperCol: { span: 24 } };
  layout4 = { labelCol: { span: 8 }, wrapperCol: { span: 20 } };

  placeholder = {
    dealUnitPrice: '等待获取...',
    // exitShareRatio: '',
    exitUnitPrice: '',
    cost: '等待计算...【公式=该轮原始交易每股单价*实际退出股数】'
  };
  shareNumDisable = false;

  @Prop()
  detail;

  @Prop()
  editType;

  @Prop()
  dealList;

  @Prop()
  index;

  @Prop()
  investDisabled;

  @Prop()
  effectDate;

  async created() {
    let { cost } = this.detail;
    console.log('detail', this.detail);

    this.form = this.detail;
    this.$nextTick(() => {
      this.form.cost = cost;
    });
    this.dealNow = {};
  }

  @Watch('form.investId')
  investChange(val, oldVal) {
    this.selectDeal(val, oldVal);
    this.calCost();
  }

  @Watch('effectDate')
  effectDateChange(val) {
    this.setCurrency();
  }

  @Watch('form.shareNum')
  shareNumChange(val) {
    this.calCost();
  }

  @Watch('dealList')
  dealListChange(list) {
    let { investId } = this.form;
    let { investDisabled } = this;
    if (investId) {
      let deal = list.find(_ => _.id === investId);
      if (investDisabled && !deal) {
        this.$emit('dateInvalid');
      } else if (!deal) {
        this.form.investId = null;
      } else {
        this.selectDeal(investId, null);
      }
    }
  }

  // 计算退出回报
  get exitReturn() {
    let { dealUnitPrice, shareNum, cost, amount } = this.form;
    return (cost || cost === 0) && (amount || amount === 0) ? amount - cost : undefined;
  }

  // 计算退出每股单价
  // 退出收入/ 退出股数
  get exitUnitPrice() {
    let { shareNum, amount } = this.form;
    return shareNum ? (amount / shareNum).toFixed(2) : undefined;
  }

  get invests() {
    return this.$store.state.middlePageDetail.invest.map(_ => {
      return {
        id: _.dealId,
        currency: _.currency,
        investEventTrades: _.investEventTrades
      };
    });
  }

  calCost() {
    (this.$refs.form as any).clearValidate('cost');
    let { dealUnitPrice, shareNum } = this.form;
    let priceAvailable = +dealUnitPrice || dealUnitPrice === 0 || (dealUnitPrice && +dealUnitPrice === 0);
    let shareNumAvailable = +shareNum || shareNum === 0 || (shareNum && +shareNum === 0);
    if (shareNumAvailable && priceAvailable) {
      this.form.cost = (+this.form.dealUnitPrice * +shareNum).toFixed(2);
    } else {
      this.form.cost = '';
    }
  }

  deleteExit() {
    this.$emit('deleteExit', this.index);
  }

  selectDeal(val, oldVal) {
    let deal = this.dealList.find(_ => _.id === val); // dealId
    this.dealNow = deal;
    if (!deal) {
      return;
    }
    let { shareNum, amount, currency } = deal;

    // 前端通过生效时间和交易对应的历史事件来判断展示的币种
    this.setCurrency();
    if (+shareNum) {
      this.form.dealUnitPrice = amount / shareNum;
      this.shareNumDisable = false;
    } else {
      this.form.dealUnitPrice = '';
      this.form.shareNum = 0;
      this.shareNumDisable = true;
    }
    this.resetRule(deal);
    this.$emit('selectDeal', { val, oldVal });
  }

  setCurrency() {
    let { investId } = this.form;
    if (investId) {
      console.log(
        'investId',
        investId,
        this.invests.find(_ => +_.id === +investId)
      );

      //  对应的交易记录的 最近一次事件： 退出交易记录的生效时间 >= 退出对应的交易对应的事件生效时间 , 然后取生效时间最大的事件
      let res = this.invests.find(_ => +_.id === +investId).currency;

      let eventList = this.invests.find(_ => _.id === investId).investEventTrades;

      if (eventList && eventList.length) {
        let event = eventList
          .filter(_ => {
            return +this.effectDate.format('YYYYMMDD') >= +_.eventEffectDate;
          })
          .sort((a, b) => {
            return +b.eventEffectDate - +a.eventEffectDate;
          });
        if (event.length) {
          res = event[0].eventCurrency;
        }
      }

      this.form.currency = res;
    }
  }

  resetRule(deal) {
    let { unrealizedShareNum, unrealizedCost } = deal;
    this.rules.shareNum[2] = {
      validator: (rule, val, cb) => {
        if (+val > +unrealizedShareNum) {
          cb(new Error(`超出剩余股份(${unrealizedShareNum})`));
        } else {
          cb();
        }
      },
      trigger: ['change', 'blur']
    };
    this.rules.cost[2] = {
      validator: (rule, val, cb) => {
        if (+val > +unrealizedCost) {
          cb(new Error(`超出剩余投资成本(${unrealizedCost})`));
        } else {
          cb();
        }
      },
      trigger: ['change', 'blur']
    };
  }

  formatNum(value) {
    return `${value}`.replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
  }

  parseNum(value) {
    return value.replace(/\$\s?|(,*)/g, '');
  }

  async save() {
    let { editType, form } = this;
    try {
      let res = await dealExit({
        ...form,
        manageType: editType,
        deliveryDate: form.deliveryDate.format('YYYYMMDD')
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.$emit('hide');
        this.$emit('refresh');
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}

export default ExitDeal;
